import React from 'react';
import styles from './neonTitle.module.css';

export default function NeonTitle({ text, size = "4xl", Textcolor }) {

  const finalColor = Textcolor && Textcolor.trim() !== ""
    ? Textcolor
    : "--cosmic-cyan";

  const isCSSVar = finalColor.startsWith("--");

  return (
    <h2
      className={`${styles.neonTitle} text-${size}`}
      style={{
        color: isCSSVar ? `var(${finalColor})` : finalColor
      }}
    >
      {text}
    </h2>
  );
}
